<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="note" style="margin-top:10px;" :class="noteClass">
                <h4 class="block">
                    <strong>Resumo deste atendimento</strong>
                </h4>

                <div style="line-height:24px;font-size:14px;">
                    <div v-if="form.statusInfo">
                        <strong>Status: {{ form.statusInfo.name }} / {{ form.situationInfo.name}}</strong>
                    </div>
                    <div v-if="!form.statusInfo">
                        <strong>Status: {{ form.situationInfo.name}}</strong>
                    </div>

                    <div v-if="form.situation === 1">Atendimento iniciado há
                        <strong>&nbsp;{{ form.created_at | timeago }}</strong>
                    </div>

                    <div v-if="form.situation === 1">Responsável
                        <strong>&nbsp;{{ form.user.name }}</strong>
                    </div>

                    <div v-if="form.last_visit_at">
                        Visita realizada
                        <strong>{{ form.total_properties_visited }}</strong>
                        imóveis visitados, a última visita foi dia
                        <strong>{{ form.last_visit_at | date }}</strong>
                        - ({{ form.last_visit_at | timeago }})
                    </div>

                    <div style="margin-top: 15px;">
                        <a class="btn blue" v-bind:href="formUrl">Ver atendimento</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    const { usesNewForms } = require('routes/forms/components/mixins/newFormsFlag')

    export default {
        props: {
            options: {},
            form: {
                twoWay: true
            }
        },
        computed: {
            formUrl () {
                const formGroupId = this.form.statusInfo && this.form.statusInfo.form_group_id

                if (usesNewForms() && formGroupId) {
                    return `/forms/new/${formGroupId}/deal/${this.form.id}`
                }

                return `/forms/${this.form.id}`
            },
            noteClass () {
                switch (this.form.situation) {
                    case 1: return 'note-info'
                    case 2: return 'note-success'
                    case 3: return 'note-danger'
                    default: return 'note-default'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// WidgetView.vue?593a3a68